import component from "./EmbeddedPage";
export default component;
